export default __webpack_public_path__ + "static/media/nutrition2.d831616d.gif";